module.exports = __webpack_public_path__ + "../resources/img/qr-android-pro.ec41c357.png";